import $ from 'jquery';

// import script accordingly
// import "./themes/header/_header";
// import "./themes/header/_footer";

document.querySelectorAll('.quantity').forEach((quantity) => {
	const input = quantity.querySelector('.qty');

	if (!quantity.querySelector('.quantity-minus')) {
		quantity.insertAdjacentHTML(
			'beforeend',
			'<span class="quantity-minus">−</span><span class="quantity-plus">+</span>',
		);

		const minus = quantity.querySelector('.quantity-minus');
		const plus = quantity.querySelector('.quantity-plus');

		plus.addEventListener('click', () => {
			input.stepUp();
			input.dispatchEvent(new Event('change'));
		});

		minus.addEventListener('click', () => {
			if (parseInt(input.value) > parseInt(input.min || 1)) {
				input.stepDown();
				input.dispatchEvent(new Event('change'));
			}
		});
	}
});
